import { FontProps, fontCss, mobileFontCss } from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

const SubTextUiNew = styled.small<FontProps>`
  ${fontCss}
  ${p => p.theme.phone} {
    ${mobileFontCss}
  }
  ${p => p.theme.isEditorMobileMode && mobileFontCss}
`

export default SubTextUiNew
